getAgentKeepAlive